import { render } from "./analyticPercentage.vue?vue&type=template&id=9b07b2f6"
import script from "./analyticPercentage.vue?vue&type=script&lang=js"
export * from "./analyticPercentage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__